import ApplicationAdapter from './application';

export default class ReportAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
